import i18n from "../../../../i18n";
import {Artifact} from "../../../../types";

type ArtifactTitleRule = {
    label: string;
    ownTitle?: (payload: Record<string, unknown> | undefined) => string | null;
};

const TITLE_RULES: Record<string, ArtifactTitleRule> = {
    email_draft: {
        label: "artifact.emailDraft.titleFallback",
        ownTitle: (payload) =>
            (payload?.subject as string | undefined)?.trim() || null,
    },
    search_results: {
        label: "artifact.searchResults.titleFallback",
        ownTitle: (payload) => {
            const query = (payload?.query as string | undefined)?.trim();
            return query
                ? i18n.t("artifact.searchResults.resultsFor", {query})
                : null;
        },
    },
};

export function getArtifactTypeLabel(type?: string): string {
    if (!type) return i18n.t("artifact.pending.titleFallback");
    return i18n.t(TITLE_RULES[type]?.label ?? "artifact.generic.titleFallback");
}

export function getArtifactOwnTitle(artifact: Artifact): string | null {
    return TITLE_RULES[artifact.type]?.ownTitle?.(artifact.payload) ?? null;
}

export function getArtifactTitle(artifact: Artifact): string {
    return getArtifactOwnTitle(artifact) ?? getArtifactTypeLabel(artifact.type);
}

export function artifactAwaitsOwnTitle(artifact: Artifact): boolean {
    return (
        TITLE_RULES[artifact.type]?.ownTitle !== undefined &&
        getArtifactOwnTitle(artifact) === null
    );
}
